module.exports = __webpack_public_path__ + "static/media/3-8.7b095553.mp3";